import { Injectable } from '@angular/core';
import { ContractNumberSearchModel } from 'src/app/models/ContractNumberSearchModel';

import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';
import { VccSearchModel } from '../../pages/dialogs/request-target-search/vcc-request-search-modal/vcc-request-search-modal.component';
import { XrefRelationshipModel } from '../../models/XrefRelationshipModel';
import { RfxMetaDataRequest } from '../../models/RfxMetaDataRequest';
import { ProductSourceTypeModel } from '../../models/ProductSourceTypeModel';
import { RequestData } from '../../pages/requests/my-requests/my-requests.component';

export interface GetRfxParams {
  rfxHeaderKey: number;
  sourceType?: ProductSourceTypeModel;
  sourceId?: number;
}

interface FilterCriteria {
  memberIdList?: number[];
}

interface XrefListResponse {
  requests: RequestData[];
}

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  baseUrl = window.location.origin;
  token = '';
  constructor(
    private baseAPIService: BaseApiService,
    public user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });
  }

  getContractNumberSearchResults(
    contractNumber: string,
  ): Promise<ContractNumberSearchModel[]> {
    let url =
      this.baseUrl +
      '/api/Contract/SearchByContractNumber?contractNumber=' +
      contractNumber;
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<ContractNumberSearchModel[]>(url);
  }

  getRfxCrosses({
    rfxHeaderKey,
    sourceType,
    sourceId,
  }: GetRfxParams): Promise<XrefRelationshipModel[]> {
    const url = this.baseUrl + '/api/Rfx/GetCrosses';
    const pathParams = {
      rfxHeaderKey: rfxHeaderKey,
      sourceType: sourceType,
      sourceId: sourceId,
    };
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.getTU<XrefRelationshipModel[]>(url, pathParams);
  }

  getVccSearchResults(partialVccName: string): Promise<VccSearchModel[]> {
    let url =
      this.baseUrl +
      '/api/Contract/SearchByVizientContractCategory?partialVcc=' +
      partialVccName;
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.get<VccSearchModel[]>(url);
  }

  getRfxMetaData({
    rfxHeaderKey,
    sourceType,
    sourceId,
  }: GetRfxParams): Promise<RfxMetaDataRequest> {
    const url = this.baseUrl + '/api/Rfx/GetMetaData';
    const pathParams = {
      rfxHeaderKey: rfxHeaderKey,
      sourceType: sourceType,
      sourceId: sourceId,
    };
    this.baseAPIService.headerToken = this.token;
    return this.baseAPIService.getTU<RfxMetaDataRequest>(url, pathParams);
  }

  createRfx(
    incumbentSourceId: number,
    incumbentSourceType: string,
    { memberIdList }: FilterCriteria,
  ): Promise<number> {
    let url = this.baseUrl + '/api/Rfx/Create';
    this.baseAPIService.headerToken = this.token;
    const params = {
      incumbentSourceId,
      incumbentSourceType,
      memberIdList,
    };

    return this.baseAPIService.postTU<
      {
        incumbentSourceId: number;
        incumbentSourceType: string;
        memberIdList?: number[];
      },
      number
    >(url, params);
  }

  listRfxForUser() {
    let url = this.baseUrl + '/api/Rfx/List';
    this.baseAPIService.headerToken = this.token;

    return this.baseAPIService.getTU<XrefListResponse>(url);
  }

  sendRfx(
    rfxHeaderKey: number,
    competingSourceId?: number,
    competingSourceType?: string,
  ) {
    let url = this.baseUrl + '/api/Rfx/Send';
    this.baseAPIService.headerToken = this.token;

    return this.baseAPIService
      .postTU(url, {
        rfxHeaderKey: rfxHeaderKey,
        competingSourceId: competingSourceId,
        competingSourceType: competingSourceType,
      })
      .then(response => {
        return response as number; // RFX Header Key
      });
  }

  async sendRfxEmail(
    rfxHeaderKey: number,
    targetEmail: string,
    monthsOldVerificationToKeep: number,
    competingSourceId?: number,
    competingSourceType?: string,
  ) {
    let url = this.baseUrl + '/api/Rfx/SendRequest';
    this.baseAPIService.headerToken = this.token;

    const response = await this.baseAPIService.postTU(url, {
      rfxHeaderKey: rfxHeaderKey,
      competingSourceId: competingSourceId,
      competingSourceType: competingSourceType,
      targetEmail: targetEmail,
      monthsOldVerificationToKeep: monthsOldVerificationToKeep,
    });
    return response as number;
  }
}
